document.addEventListener("DOMContentLoaded", function () {
  initializeTimelineCarousels();

  function initializeTimelineCarousels() {
    const carousels = document.querySelectorAll(
      ".manitoba-timeline-carousel .swiper"
    );

    carousels.forEach(function (carousel) {
      new Swiper(carousel, {
        slidesPerView: 1,
        spaceBetween: 50,
        grabCursor: true,
        navigation: {
          nextEl: carousel.querySelector(".swiper-button-next"),
          prevEl: carousel.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      });
    });
  }
});
